// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"d0bcaa53","464":"4571c730","663":"a3b7a418","725":"4713fd26","941":"8dd1ab88"}[chunkId] + ".chunk.js";
};